import { Component, Input } from '@angular/core';
import { LocalizationService, LocalizedNumberFormat } from 'src/app/shared/localization/localization.service';
import { ICaseViewModel, IClaimSettings, RequirementsTotalCalculator } from 'src/app/shared/models';

@Component({
  selector: 'app-case-requirements',
  templateUrl: './case-requirements.component.html',
  styleUrls: ['./case-requirements.component.scss'],
})
export class CaseRequirementsComponent {

  constructor(public localizationService: LocalizationService) { }

  @Input() case: ICaseViewModel;
  @Input() hasInternationalCurrency: boolean;
  @Input() firmCurrencyCode: string;
  @Input() numberFormat: LocalizedNumberFormat;
  @Input() firmClaimSettings: IClaimSettings;

  showDetailedFees: boolean = false;


  get totals(): RequirementsTotalCalculator & { remitted: number } {
    if (!this.case?.requirements) return undefined;

    const car = this.case.requirements;

    return Object.assign(new RequirementsTotalCalculator(car)
      , { remitted: car.remittedCapital + car.remittedInterest + car.remittedPublicFee + this.SveasFees.remitted }
    );
  }


  get SveasFees(): { original: number, paid: number, rest: number, restValuta: number, remitted: number } {

    if (!this.case?.requirements) return undefined;

    const car = this.case.requirements;

    return {
      original: car.originalChargeInterest
        + car.originalFee
        + car.originalAdditionalFee
        + car.originalNewCaseFee
        + car.originalCustomerReminderFee
        + car.originalEuFee,
      paid: car.paidChargeInterest
        + car.paidFee
        + car.paidAdditionalFee
        + car.paidEuFee
        + car.paidNewCaseFee
        + car.paidCustomerReminderFee
        + car.paidEuFee,
      rest: car.restChargeInterest
        + car.restFee
        + car.restAdditionalFee
        + car.restNewCaseFee
        + car.restCustomerReminderFee
        + car.restEuFee,
      restValuta: car.restValutaChargeInterest
        + car.restValutaFee
        + car.restValutaAdditionalFee
        + car.restValutaNewCaseFee
        + car.restValutaCustomerReminderFee
        + car.restValutaEuFee,
      remitted:
        car.remittedFee
        + car.remittedAdditionalFee
        + car.remittedNewCaseFee
        + car.remittedCustomerReminderFee
        + car.remittedEuFee,
    }
  }

  get DetailedFees(): { translationTag: string, rate: number, original: number, paid: number, rest: number, restValuta: number, invoiced: number, remitted: number }[] {

    if (!this.case?.requirements || !this.firmClaimSettings) return undefined;

    const detailedFees = [];
    const car = this.case.requirements;

    const feeTypes = [
      {
        enabled: 'isAdditionalFeeEnabled',
        tag: 'Case.Requirements.ClaimType.AdditionalFee',
        prefix: 'AdditionalFee'
      },
      {
        enabled: 'isCustomerReminderFeeEnabled',
        tag: 'Case.Requirements.ClaimType.CustomerReminderFee',
        prefix: 'CustomerReminderFee'
      },
      {
        enabled: 'isEuFeeEnabled',
        tag: 'Case.Requirements.ClaimType.EuFee',
        prefix: 'EuFee'
      },
      {
        enabled: 'isFeeEnabled',
        tag: 'Case.Requirements.ClaimType.Fee',
        prefix: 'Fee'
      },
      {
        enabled: 'isChargeInterestEnabled',
        tag: 'Case.Requirements.ClaimType.ChargeInterest',
        prefix: 'ChargeInterest'
      },
      {
        enabled: 'isNewCaseFeeEnabled',
        tag: 'Case.Requirements.ClaimType.NewCaseFee',
        prefix: 'NewCaseFee'
      }
    ];

    feeTypes.forEach(fee => {
      if (this.firmClaimSettings[fee.enabled]) {
        detailedFees.push({
          translationTag: fee.tag,
          rate: car[`${fee.prefix.decapitalize()}Rate`],
          original: car[`original${fee.prefix}`],
          paid: car[`paid${fee.prefix}`],
          rest: car[`rest${fee.prefix}`],
          restValuta: car[`restValuta${fee.prefix}`],
          invoiced: car[`customers${fee.prefix}`],
          remitted: car[`remitted${fee.prefix}`]
        });
      }
    });

    return detailedFees;
  }
}
